import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  clearAllItemsFromLocalStorage,
  getItemFromLocalStorage,
  storeItemInLocalStorage
} from "@/utils/localStorageHelper";
import { SignedInUser, User } from "@/models/auth";
import { Organization } from "@/models/organization";

export interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  user: User | null;
  organization: Organization | null;
  isAuthenticated: boolean;
}

export type AuthActionPayload = Omit<AuthState, "isLoggedIn">;

const initialState: AuthState = {
  accessToken: getItemFromLocalStorage("accessToken") as string | null,
  refreshToken: getItemFromLocalStorage("refreshToken") as string | null,
  user: getItemFromLocalStorage("user") as User | null,
  organization: getItemFromLocalStorage("organization") as Organization | null,
  isAuthenticated: (getItemFromLocalStorage("isAuthenticated") as boolean) ?? false
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authenticate(state, action: PayloadAction<SignedInUser>) {
      const { accessToken, refreshToken, user, organization } = action.payload;
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
      state.user = user;
      state.organization = organization;
      state.isAuthenticated = true;

      storeItemInLocalStorage("user", user);
      storeItemInLocalStorage("organization", organization);
      storeItemInLocalStorage("accessToken", accessToken);
      storeItemInLocalStorage("refreshToken", refreshToken);
      storeItemInLocalStorage("isAuthenticated", true);
    },
    updateAccessToken(state, action: PayloadAction<string>) {
      state.accessToken = action.payload;
      storeItemInLocalStorage("accessToken", action.payload);
    },
    updateRefreshToken(state, action: PayloadAction<string>) {
      state.refreshToken = action.payload;
      storeItemInLocalStorage("refreshToken", action.payload);
    },
    updateUser(state, action: PayloadAction<User>) {
      state.user = action.payload;
      storeItemInLocalStorage("user", action.payload);
    },

    updateOrganization(state, action: PayloadAction<Organization>) {
      state.organization = action.payload;
      storeItemInLocalStorage("organization", action.payload);
    },
    signOut() {
      clearAllItemsFromLocalStorage();
      sessionStorage.clear();

      return {
        accessToken: null,
        refreshToken: null,
        user: null,
        organization: null,
        role: null,
        isAuthenticated: false
      };
    }
  }
});
export const authActions = authSlice.actions;

export const authReducer = authSlice.reducer;
